import { produce } from 'immer';
import { RECEIVE_ENTITIES, RECEIVE_GROUPING_LEVELS, REQUEST_ENTITIES, REQUEST_GROUPING_LEVELS, RECEIVE_BUCKET_LEVELS, REQUEST_BUCKET_LEVELS } from "./actionTypes";

const defaultState = {
  groupingLevels: [],
  groupingLevelsFetching: false,
  entities: [],
  bucketLevels: [],
  bucketLevelsFetching: false,
  fetchingEntities: false,
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_GROUPING_LEVELS: {
      state.groupingLevels = defaultState.groupingLevels;
      state.groupingLevelsFetching = true;
      break;
    }
    case RECEIVE_GROUPING_LEVELS: {
      state.groupingLevels = action.data;
      state.groupingLevelsFetching = false;
      break;
    }
    case REQUEST_BUCKET_LEVELS: {
      state.bucketLevels = defaultState.bucketLevels;
      state.bucketLevelsFetching = true;
      break;
    }
    case RECEIVE_BUCKET_LEVELS: {
      state.bucketLevels = action.data;
      state.bucketLevelsFetching = false;
      break;
    }
    case REQUEST_ENTITIES: {
      state.entities = defaultState.entities;
      state.fetchingEntities = true;
      break;
    }
    case RECEIVE_ENTITIES: {
      state.entities = action.data;
      state.fetchingEntities = false;
      break;
    }
    default:
      return state;
  }
});
export default reducer;